/* eslint-disable max-len */
import timeCombaine from '@/components/mixins/timeCombaine';
import programFavorite from '@/components/mixins/api/apiMethodsProgramFavorite';
// import global from '@/components/mixins/methodsGlobal';

export default {
  data() {
    return {
      userCalendar: [],
      favoriteReturnHandler: null,
    };
  },
  mixins: [timeCombaine, programFavorite],
  computed: {
    exhID() {
      return this.$store.getters.getExhId;
    },
    listMarkedID() {
      return this.userCalendar.map((item) => item.id);
    },
  },
  methods: {
    sortCalendar(calendar) {
      const sortCalendar = calendar.sort((itemA, itemB) => (itemA.start_ts !== itemB.start_ts
        ? itemA.start_ts - itemB.start_ts
        : itemA.duration_ts - itemB.duration_ts));
      const dateList = [];
      const resultCalendar = [];
      sortCalendar
        .filter((item) => item.type !== 'date')
        .forEach((item) => {
          const date = this.dateEventWeekday(this.timeStart(item.start_ts));
          if (!dateList.includes(date)) {
            dateList.push(date);
            resultCalendar.push({
              id: this.startDayTs(item.start_ts),
              start_ts: this.startDayTs(item.start_ts),
              type: 'date',
              text: date,
            });
          }
          resultCalendar.push(item);
        });
      return resultCalendar;
    },
    loadUserCalendar() {
      const jsonCalendar = localStorage.getItem(`exh-${this.exhID}-calendar`);
      const calendar = jsonCalendar ? JSON.parse(jsonCalendar) : [];
      if (calendar) this.userCalendar = this.sortCalendar(calendar);
    },
    saveUserCalendar() {
      // const calendar = this.loadUserCalendar();
      this.userCalendar = this.sortCalendar(this.userCalendar);
      localStorage.setItem(`exh-${this.exhID}-calendar`, JSON.stringify(this.userCalendar));
    },
    /**
     * Отметку показываем сразу, не дожидаясь ответа: закладка должна отзываться
     * на нажатие, а не на скорость сети.
     */
    addToUserCalendar(item) {
      this.userCalendar = [...this.userCalendar, item];

      this.saveUserCalendar();

      return this.setProgramFavorite(item, true)
        .catch((error) => this.revertFavorite(item, false, error));
    },
    removeFromUserCalendar(id) {
      const item = this.userCalendar.find((element) => element.id === id);

      this.userCalendar = this.userCalendar.filter((element) => element.id !== id);

      this.saveUserCalendar();

      if (!item) return Promise.resolve(false);

      return this.setProgramFavorite(item, false)
        .catch((error) => this.revertFavorite(item, true, error));
    },
    /**
     * Возвращает отметку в прежнее состояние, когда сервер отказал.
     *
     * `wasMarked` — как было до нажатия. Обрыв связи сюда не приводит к откату:
     * такая операция ждёт в очереди и уедет сама, а о самом обрыве baseApi уже
     * сказал своим тостом — второй о том же был бы лишним.
     */
    revertFavorite(item, wasMarked, error) {
      if (error && error.code === 'ERR_NETWORK') return false;

      this.userCalendar = wasMarked
        ? [...this.userCalendar.filter((element) => element.id !== item.id), item]
        : this.userCalendar.filter((element) => element.id !== item.id);

      this.saveUserCalendar();

      this.$store.commit('pushToast', {
        text: this.$t('userCalendar.favorite_failed'),
        type: 'danger',
      });

      return false;
    },
    /**
     * Забирает состав избранного с сервера и пересобирает карточки. Экран до
     * этого момента уже нарисован локальной копией, поэтому ошибка синхронизации
     * ничего не ломает: человек видит то, что видел, и попытка повторится.
     */
    syncUserCalendar() {
      return this.syncProgramFavorite()
        .then((cards) => {
          if (!cards) return false;

          this.userCalendar = this.sortCalendar(cards);
          this.saveUserCalendar();
          return true;
        })
        .catch((error) => {
          console.error('syncUserCalendar()::', error);
          return false;
        });
    },
    /**
     * PWA у людей живёт неделями без перезагрузки, и за это время программа
     * успевает измениться. Поэтому обновляемся не только при открытии экрана,
     * но и при возвращении в приложение.
     *
     * Подписку вешают сами экраны, а не этот миксин: одновременно открыт только
     * один из них, и так на возвращение приходится один заход, а не два.
     */
    startFavoriteSyncOnReturn() {
      if (this.favoriteReturnHandler) return;

      this.favoriteReturnHandler = () => {
        if (document.visibilityState === 'visible') this.syncUserCalendar();
      };
      document.addEventListener('visibilitychange', this.favoriteReturnHandler);
    },
    stopFavoriteSyncOnReturn() {
      if (!this.favoriteReturnHandler) return;

      document.removeEventListener('visibilitychange', this.favoriteReturnHandler);
      this.favoriteReturnHandler = null;
    },
  },
};
